import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { debounceTime, Subscription } from 'rxjs';
import { FormlyDynamicService } from '../formly-dynamic.service';
import { FilterService } from 'src/app/services/filter.service';
import { UserActivityService } from 'src/app/services/useractivity.service';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { AppCustomDatepickerHeaderComponent } from '../timecycle-with-range/app-custom-datepicker-header';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import moment from "moment";

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';

export const YEAR_ONLY_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-formly-yearly-selection',
  templateUrl: './formly-yearly-selection.component.html',
  styleUrls: ['./formly-yearly-selection.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: YEAR_ONLY_FORMATS },
  ]
})
export class FormlyYearlySelectionComponent extends FieldType implements OnInit, OnDestroy {


  exampleHeader = AppCustomDatepickerHeaderComponent
  
  minDate = new Date('1900-01-01');
  maxDate = new Date();
  
  selectedDate = new FormControl(new Date());
  
  
  tabId = 0;
  moduleName:any;
  cardName: any;
  dashboardKey:any;
  
  fieldKey:any;
  currentField:any;
  templateOptions: any;
  label:any;
  mixPanelConfiguration = false;
  compulsaryFilter = true;

  reqSubcription: Subscription[] = []
  filterBadgeObj: any = {};
  
  override field: any
  
  constructor(
    private formlyDynamicService: FormlyDynamicService,
    private filterService: FilterService,
    private userActivityService: UserActivityService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private dashboardService: DashboardService,
    private mixpanelService: MixpanelService
  ) { 
    super()
  }


  // Selected Date
  // Uniq Key
  bookmarkId:any;
  queryFilterData:any;


  yearSelected(event: Date, datepicker: any) {
    this.selectedDate.setValue(event);
    this.endDateChanges();
    datepicker.close();
  }
  
  ngOnInit(): void {
    this.fieldKey = this.key as string;
    
    this.reqSubcription.push(this.route.params.subscribe((p: any) => {
      this.moduleName = p['module'] || '';
      this.bookmarkId = p?.['bk_mrk_key'] || undefined;
      
      if(this.bookmarkId && !isNaN(Number(this.bookmarkId))) {
        this.queryFilterData = this.filterService.bookmarkFilterData;
      }


      this.route.queryParams.subscribe((params:any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.dashboardKey = decryptedParams["ds_key"];
        this.tabId = params["tab_id"];

        this.cardName = p["cardName"];
      });      
    }));
    
    // Filter Reset Method using Subject
    this.reqSubcription.push(this.filterService.formReset.subscribe((res: any) => {
      this.queryFilterData = {};

      if(!this.compulsaryFilter) {
        this.selectedDate.setValue(null);
      } else {
        this.selectedDate.setValue(this.maxDate);
      }
      
      const date = this.formlyDynamicService.findAllYearlyResetSelectedDate(this.selectedDate.value);
      this.filterService.selectedItem['formly_yearly_selection'][this.fieldKey] = JSON.parse(JSON.stringify(date));
      
      let dbDate = { [this.fieldKey]: date.selectedDate };
      this.field.formControl?.setValue(dbDate);
      
      let startYearDate = this.selectedDate.value ? moment(this.selectedDate.value).startOf('year').toDate() : null;
      let endYearDate = this.selectedDate.value ? moment(this.selectedDate.value).endOf('year').toDate() : null;

      // Set Badges
      this.formlyDynamicService.setYearlyBadges(this.fieldKey, {start: startYearDate, end: endYearDate}, this.filterBadgeObj);

    }), this.filterService.intractiveFilter.pipe(debounceTime(500)).subscribe((res: any) => {
      // debugger
      if (this.field?.key ===  res.key &&  res.type == "Y") {
        let start = new Date(res.value.from_date)
        this.selectedDate.setValue(start);
        this.endDateChanges();
      }

    }))

    this.currentField = this.field;
    this.templateOptions = this.field.templateOptions || {};

    this.label = this.templateOptions.label;
    
    this.compulsaryFilter = this.templateOptions?.compulsaryFilter == 'no' ? false : true;
    this.mixPanelConfiguration = this.templateOptions.mixPanelConfiguration == 'yes' ? true : false;
    let dateStart = this.templateOptions?.yearStartFrom || 1900;
    
    this.minDate = new Date(dateStart, 0, 1);
    this.maxDate = new Date();

    let selectedDate = this.compulsaryFilter ? this.maxDate : null;
    this.selectedDate.setValue(selectedDate);

    this.filterBadgeObj = {
      minDate:this.minDate,
      maxDate:this.maxDate,
    }

    if(!this.compulsaryFilter) {
      const date = this.formlyDynamicService.findAllYearlySelectedDate(this.selectedDate.value, false);
      this.filterService.selectedItem['formly_yearly_selection'][this.fieldKey] = JSON.parse(JSON.stringify(date));
      this.filterService.allOptionData['formly_yearly_selection'][this.fieldKey] = JSON.parse(JSON.stringify(date));
    } else {
      const date = this.formlyDynamicService.findAllYearlySelectedDate(this.selectedDate.value, true);
      this.filterService.selectedItem['formly_yearly_selection'][this.fieldKey] = JSON.parse(JSON.stringify(date));
      this.filterService.allOptionData['formly_yearly_selection'][this.fieldKey] = JSON.parse(JSON.stringify(date));
    }

    
    let fndData = false;
    let queryObj = this.queryFilterData || {};

    if(Object.keys(queryObj).length>0 && queryObj?.["carry_formly_year_filter"] && this.bookmarkId && !isNaN(Number(this.bookmarkId))) {
      let dtObj = JSON.parse(queryObj?.["carry_formly_year_filter"]) || [];
      let fndObj = dtObj.find((f:any)=> f.key == this.fieldKey);
      if(fndObj && fndObj?.selected) {
        let fomDate = new Date(fndObj.selectedDate, 0, 1);
        this.selectedDate.setValue(fomDate);
        const date = this.formlyDynamicService.findAllYearlySelectedDate(this.selectedDate.value, true);
        this.filterService.selectedItem['formly_yearly_selection'][this.fieldKey] = JSON.parse(JSON.stringify(date));
        fndData = true;
      } else {
        fndData = false;
      }
    } else {
      // User State
      let userStateData: any = this.userActivityService.getData() 
      let updatesObj: any = Object.entries(userStateData.selectedFilters).map(([key, value]) => ({ key, value }));
      let findData: any = updatesObj.find((o: any) => o.key == this.fieldKey) 
      
      if (findData?.value) {
        let fomDate = new Date(findData?.value, 0, 1);
        this.selectedDate.setValue(fomDate);

        const date = this.formlyDynamicService.findAllYearlySelectedDate(this.selectedDate.value, true);
        this.filterService.selectedItem['formly_yearly_selection'][this.fieldKey] = JSON.parse(JSON.stringify(date));
        fndData = true;

      } else {
        fndData = false;
      }
    }
    
      
    if(!this.compulsaryFilter && !fndData) {
      
      let dbDate = { [this.fieldKey] : null};
      this.field.formControl?.setValue(dbDate);

      // Set Badges
      this.formlyDynamicService.setYearlyBadges(this.fieldKey, {start: null, end: null }, this.filterBadgeObj);
    } else {

      const date = this.formlyDynamicService.findAllYearlySelectedDate(this.selectedDate.value, true);
      this.filterService.selectedItem['formly_yearly_selection'][this.fieldKey] = JSON.parse(JSON.stringify(date));

      let dbDate = { [this.fieldKey] : date.selectedDate };
      this.field.formControl?.setValue(dbDate);
      
      let startYearDate = this.selectedDate.value ? moment(this.selectedDate.value).startOf('year').toDate() : null;
      let endYearDate = this.selectedDate.value ? moment(this.selectedDate.value).endOf('year').toDate() : null;
      // Set Badges
      this.formlyDynamicService.setYearlyBadges(this.fieldKey, {start: startYearDate, end: endYearDate}, this.filterBadgeObj);

    }
  }

  endDateChanges() {
    // formly Model
    const date = this.formlyDynamicService.findAllYearlySelectedDate(this.selectedDate.value, true);
    this.filterService.selectedItem['formly_yearly_selection'][this.fieldKey] = JSON.parse(JSON.stringify(date));

    let ab = { [this.fieldKey]: date.selectedDate }
    this.userActivityService.setData({ "selectedFilters": ab })

    if(this.mixPanelConfiguration) {
      let mixPanel = this.moduleName + ' - ' + this.dashboardService.dashboardName + ' - ' + this.label + ' - ' + 'Filter';
      this.mixpanelService.track(mixPanel);
    }
    
    let dbDate = { [this.fieldKey]: date.selectedDate };
    this.field.formControl?.setValue(dbDate);

    let startYearDate = this.selectedDate.value ? moment(this.selectedDate.value).startOf('year').toDate() : null;
    let endYearDate = this.selectedDate.value ? moment(this.selectedDate.value).endOf('year').toDate() : null;
    // Set Badges
    this.formlyDynamicService.setYearlyBadges(this.fieldKey, {start: startYearDate, end: endYearDate}, this.filterBadgeObj);
  }
  
  compulsaryFilterValidation() {
    if(!this.compulsaryFilter && 
      this.filterService?.allOptionData?.['formly_yearly_selection']?.[this.fieldKey]?.selectedDate == 
      this.filterService?.selectedItem?.['formly_yearly_selection']?.[this.fieldKey]?.selectedDate) {
      return false;
    } else {
      if(this.compulsaryFilter) {
        return false;
      } else {
        return true;
      }
    }
  }

  clearDateFilter() {
    this.selectedDate.setValue(null);
    this.endDateChanges()
    
    let ab = { [this.fieldKey]: null }
    this.userActivityService.setData({ "selectedFilters": ab })
   
    let dbDate = { [this.fieldKey] : null};
    this.field.formControl?.setValue(dbDate);

    let startYearDate = this.selectedDate.value ? moment(this.selectedDate.value).startOf('year').toDate() : null;
    let endYearDate = this.selectedDate.value ? moment(this.selectedDate.value).endOf('year').toDate() : null;

    // Set Badges
    this.formlyDynamicService.setYearlyBadges(this.fieldKey, {start: startYearDate, end: endYearDate}, this.filterBadgeObj);
    
    const date = this.formlyDynamicService.findAllYearlySelectedDate(this.selectedDate.value, false);
    this.filterService.selectedItem['formly_yearly_selection'][this.fieldKey] = JSON.parse(JSON.stringify(date));
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}
